import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';

export default function NotesHighlightsCard({ notes }) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border hover-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-crimson font-semibold text-foreground">Recent Notes & Highlights</h3>
        <Icon name="PencilIcon" size={24} className="text-primary" />
      </div>
      <div className="space-y-3">
        {notes?.slice(0, 4)?.map((note) => (
          <div key={note?.id} className="p-3 bg-surface rounded-lg border-l-4 border-primary/30">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-inter font-medium text-foreground">{note?.reference}</span>
              <span className="text-xs font-inter text-muted-foreground">{note?.date}</span>
            </div>
            <p className="text-sm font-source-serif text-muted-foreground mb-2 italic">"{note?.verse}"</p>
            <p className="text-sm font-inter text-foreground">{note?.note}</p>
          </div>
        ))}
        
        <button className="w-full mt-4 px-4 py-2 border border-primary text-primary rounded-lg font-inter font-medium text-sm hover:bg-primary hover:text-primary-foreground contemplative-transition">
          View All Notes
        </button>
      </div>
    </div>
  );
}

NotesHighlightsCard.propTypes = {
  notes: PropTypes?.arrayOf(
    PropTypes?.shape({
      id: PropTypes?.number?.isRequired,
      reference: PropTypes?.string?.isRequired,
      verse: PropTypes?.string?.isRequired,
      note: PropTypes?.string?.isRequired,
      date: PropTypes?.string?.isRequired
    })
  )?.isRequired
};